import { css } from 'styled-components';
const def = (value, predef) => {
  if (value === 'default') return predef;
  return value ?? false;
};
const focusColor = ({
  theme,
  $reverseFocus
}) => $reverseFocus ? theme.focusColorReverse : theme.focusColor;
const focusWidth = ({
  theme
}) => theme.focusWidth;
const focusRadius = ({
  theme
}) => theme.focusRadius;
const focusBoxShadow = ({
  theme,
  $reverseFocus
}) => $reverseFocus ? theme.focusBoxShadowReverse : theme.focusBoxShadow;
export const focusOutlineCss = css`
  outline: ${focusWidth} solid ${focusColor};
`;
export const fallbackFocusWithinCss = css`
  position: relative;

  &:focus-within::before {
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 1;

    margin: -3px;
    border-radius: ${focusRadius};
    box-shadow: ${focusBoxShadow};
  }
`;
export const focusVisibleWithBefore = css`
  position: relative;

  &:focus-visible::before {
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 1;

    border: ${focusWidth} solid ${focusColor};
  }
`;
export const focusOutline = ({
  offset = null,
  radius = null
} = {}) => {
  return ({
    theme
  }) => {
    const withOffset = def(offset, theme.focusOffset);
    const withRadius = def(radius, theme.focusRadius);
    return css`
      ${focusOutlineCss}
      ${withOffset && `outline-offset: ${withOffset};`}
      ${withRadius && `border-radius: ${withRadius};`}
    `;
  };
};
export const focusVisibleWithOutline = ({
  offset = null,
  radius = null
} = {}) => {
  return css`
    &:focus-visible {
      ${focusOutline({
    offset,
    radius
  })}
    }
  `;
};
//# sourceMappingURL=focus-indicator.js.map